import { render } from "./SwapMarketplace.vue?vue&type=template&id=94e31f0e&scoped=true"
import script from "./SwapMarketplace.vue?vue&type=script&lang=js"
export * from "./SwapMarketplace.vue?vue&type=script&lang=js"

import "./SwapMarketplace.vue?vue&type=style&index=0&id=94e31f0e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94e31f0e"]])

export default __exports__